module.exports = __webpack_public_path__ + "static/media/SVARIEDAD_MENU-normal.dba7e8e3.png";